import { OrderTypes } from 'shell/constants/order-types';
import { Operation } from 'shell/view-models/operation';
import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { FiltersFormOperator } from 'system/view-models/operator-list';

export const transformDataset = (values: FiltersFormOperator): string => {
  const { orders, page, rowsPerPage, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    nominativo: { value: otherValues.name, operation: Operation.LIKE },
    codiceServizio: { value: otherValues.serviceCode?.id || '', operation: Operation.LIKE },
    descrizioneServizio: { value: otherValues.service, operation: Operation.LIKE },
    descrizioneQualifica: { value: otherValues.qualification, operation: Operation.LIKE },
    userName: { value: otherValues.code, operation: Operation.LIKE },
    codana: { value: otherValues.codana, operation: Operation.EQUALS },
    codiceFiscale: { value: otherValues.fiscalCode || '', operation: Operation.LIKE },
  };

  const ordersToTransform = orders || { name: OrderTypes.Asc };
  const ordersMapped: Order = {
    nominativo: ordersToTransform.name,
    codiceServizio: ordersToTransform.serviceCode,
    descrizioneBreveServizio: ordersToTransform.service,
    descrizioneQualifica: ordersToTransform.qualification,
    userName: ordersToTransform.code,
    scadenzaAutorizzazione: ordersToTransform.dateDeadline,
    codiceFiscale: ordersToTransform.fiscalCode,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
    page,
    rowsPerPage,
  })}`;
};
